import { Matrix3, Vector2, Vector3 } from "three";
import { transformVectorAs2d } from "../threejs_utilities/transform_utilities";

export {clampToRectangle} from "./pixi_bounds";
export {calculateScreenSpaceScale} from "./pixi_scale";

export const calculateLocationCoords = (coordinates: Vector3, bounds: { width: number, height: number }, transform: Matrix3): Vector2 => {
  const coords = transformVectorAs2d(coordinates, transform);
  coords.x *= bounds.width;
  coords.y *= bounds.height;
  return coords;
};
